import { UserEmailVerifyInputDto } from '@starsoft/common/dto';
import { Success } from '@starsoft/common/models';
import { AxiosInstance, AxiosResponse } from 'axios';

export async function fetchVerifyUserEmail(
  data: UserEmailVerifyInputDto,
  axiosInstance: AxiosInstance,
) {
  const response: AxiosResponse<Success> = await axiosInstance.patch(
    '/user-emails/verify',
    data,
  );

  return response.data;
}
